import { useToast } from "@chakra-ui/react";
import { StripeBillingPortalAction } from "@syla/shared/types/requests/CreateStripeBillingPortalRequest";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { ButtonVariant } from "../../../components/atoms/ButtonVariant";
import { errorToastOptions } from "../../../components/molecules/errorToastOptions";
import { captureRequestError } from "../../../helper/captureRequestError";
import { getFullPageUrl } from "../../../helper/getFullPageUrl";
import { redirectTo } from "../../../helper/RedirectTo";
import { useMutationCreateStripeBillingPortalSession } from "../../../store/useMutationCreateStripeBillingPortalSession";
import { useStripePortalRedirectStore } from "../../../store/useStripePortalRedirectStore";

export const ChangePlanButton = ({
  accountId,
  stripeSubscriptionId,
}: {
  accountId: string;
  stripeSubscriptionId: string;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const toast = useToast(errorToastOptions);
  const { mutateAsync } = useMutationCreateStripeBillingPortalSession();

  const { isRedirecting, startRedirect, endRedirect } =
    useStripePortalRedirectStore();

  const handleClick = async () => {
    if (!startRedirect()) {
      return;
    }
    setIsLoading(true);

    try {
      const response = await mutateAsync({
        accountId,
        stripeSubscriptionId,
        action: StripeBillingPortalAction.UpdateSubscription,
        returnUrl: getFullPageUrl(location),
      });

      redirectTo(response.portalUrl);
    } catch (error) {
      captureRequestError(error);
      toast({
        title: "Failed to open billing portal",
        description: "An unexpected error occurred. Please try again later.",
      });
      endRedirect();
      setIsLoading(false);
    }
    // no cleanup of loading state on success, as the page will redirect,
    // ensuring the loading spinner continues until redirect is complete
  };

  return (
    <ButtonVariant
      isDisabled={isRedirecting}
      isLoading={isLoading}
      content="Change Plan"
      outlineType="outlineBlack"
      size="sm"
      onClick={handleClick}
    ></ButtonVariant>
  );
};
